var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 9,
    viewBox: "0 0 12 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.08114 3.34941C7.63174 3.33618 8.12357 3.00178 8.33829 2.49466C8.38412 2.51399 8.43314 2.52464 8.48286 2.52609H10.9971C11.2575 2.52609 11.4686 2.31505 11.4686 2.05472C11.4686 1.7944 11.2575 1.58336 10.9971 1.58336H8.51429C8.48716 1.5798 8.45969 1.5798 8.43257 1.58336C8.25253 0.876059 7.55974 0.425304 6.84005 0.547204C6.12036 0.669104 5.61469 1.32285 5.67768 2.04997C5.74066 2.7771 6.35121 3.33419 7.08114 3.33055V3.34941ZM7.08114 1.49537C7.33456 1.49537 7.54 1.70078 7.54 1.95417C7.54 2.20755 7.33456 2.41296 7.08114 2.41296C6.82772 2.41296 6.62229 2.20755 6.62229 1.95417C6.62229 1.70078 6.82772 1.49537 7.08114 1.49537Z",
    fill: "#969696"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.971429 1.58336H4.74286C5.00322 1.58336 5.21429 1.7944 5.21429 2.05472C5.21429 2.31505 5.00322 2.52609 4.74286 2.52609H0.971429C0.711066 2.52609 0.5 2.31505 0.5 2.05472C0.5 1.7944 0.711066 1.58336 0.971429 1.58336Z",
    fill: "#969696"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.172 6.61125C2.36889 6.05445 2.89506 5.6819 3.48571 5.68109V5.66852C4.19651 5.66762 4.79547 6.19881 4.87941 6.90454C4.96335 7.61027 4.50569 8.2671 3.81451 8.4329C3.12332 8.5987 2.41743 8.22098 2.172 7.55398H0.971429C0.711066 7.55398 0.5 7.34295 0.5 7.08262C0.5 6.82229 0.711066 6.61125 0.971429 6.61125H2.172ZM3.02762 7.11568C3.03193 7.36567 3.23565 7.56618 3.48571 7.56655V7.54141C3.73913 7.54141 3.94457 7.336 3.94457 7.08262C3.93087 6.83297 3.71977 6.64025 3.46987 6.64926C3.21997 6.65827 3.0233 6.86569 3.02762 7.11568Z",
    fill: "#969696"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6 6.61125H11.0286C11.2889 6.61125 11.5 6.82229 11.5 7.08262C11.5 7.34295 11.2889 7.55398 11.0286 7.55398H6C5.73964 7.55398 5.52857 7.34295 5.52857 7.08262C5.52857 6.82229 5.73964 6.61125 6 6.61125Z",
    fill: "#969696"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/Filter.40747a8ed2f152b806897604300ea5ca.svg";
export { ForwardRef as ReactComponent };